/* eslint-disable @nx/enforce-module-boundaries */
import { IResponseModel, IFeatureToggle } from '@agenda-customer-ui/shared';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { FeatureToggleCodes } from './feature-codes.enum';
import { map } from 'rxjs/internal/operators/map';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { StorageKeys } from '@core/enums';
import { SessionService } from '../session/session.service';
import { API, environment } from '@core/envs';

@Injectable({
  providedIn: 'root'
})
export class FeatureToggleService {
  isLoaded = new BehaviorSubject(false);
  list: { [key in FeatureToggleCodes]?: IFeatureToggle } = {};
  readonly #isPublicAPI = true;

  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) { }

  getList(country: string, forceRefresh = false): Observable<{ [key in FeatureToggleCodes]?: IFeatureToggle }> {
    this.list = this.#getFromStorage();

    // Fetch list if not in session storage
    if (!Object.keys(this.list).length || forceRefresh) {
      const api = environment.getRoute(API.backoffice, this.#isPublicAPI);
      const url = `${api}/feature-toggle/v1/${country}`;
      return this.http.get<IResponseModel<IFeatureToggle[]>>(url).pipe(
        map(response => {
          this.list = response.response.reduce((acc, item) => {
            if (Object.values(FeatureToggleCodes).includes(item.code as FeatureToggleCodes)) {
              acc[item.code as FeatureToggleCodes] = item;
            }
            return acc;
          }, {} as { [key in FeatureToggleCodes]?: IFeatureToggle });

          this.sessionService.setObject(StorageKeys.FEATURE_TOGGLE, this.list);
          this.isLoaded.next(true);
          return this.list;
        }),
      );
    }

    // return list from session storage if available
    return new Observable(subscriber => {
      subscriber.next(this.list);
      subscriber.complete();
      this.isLoaded.next(true);
    });
  }

  #getFromStorage(): { [key in FeatureToggleCodes]?: IFeatureToggle } {
    return this.sessionService.getObject(StorageKeys.FEATURE_TOGGLE);
  }
}
